// extracted by mini-css-extract-plugin
module.exports = {"notifications":"Notifications_notifications__VUnJ_","notification":"Notifications_notification__1Th5F"};